#import "./NotesEntityFields.graphql"
mutation UpdateNote($input: NoteUpdateInput!) {
  noteUpdate(input: $input) {
    note {
      ...NotesEntityFields
    }
  }
}
